// TABLE
export const columnsTableLw = [
  {
    name: 'Acciones',
    isVisible: true,
  },
  {
    name: 'Estado',
    value: 'id_estado',
    isVisible: true,
  },
  {
    name: 'Fecha',
    value: 'fecha',
    isVisible: true,
  },
  {
    name: 'Monto',
    value: 'monto',
    isVisible: true,
  },
  {
    name: 'Categoría',
    value: 'id_categoria',
    isVisible: true,
  },
  {
    name: 'Agente',
    value: 'agente',
    isVisible: true,
  },
  {
    name: 'Creado Por',
    value: 'creado_por',
    isVisible: true,
  },
  {
    name: 'Actualizado Por',
    value: 'updated_by',
    isVisible: true,
  },
];

export const agentTypes = [
  { value: 3, label: 'Agente' },
  { value: 4, label: 'Agente Afiliador' },
];

//ESTADOS
interface StateClass {
  text: string;
  classes: { [key: string]: boolean };
}

export const STATE_LW_CLASSES: { [key: number]: StateClass } = {
  1: { text: 'Pendiente', classes: { 'bg-pending': true } },
  2: { text: 'Procesado', classes: { 'bg-processing': true } },
  3: { text: 'Bono', classes: { 'bg-bonus': true } },
  9: { text: 'Anulado', classes: { 'bg-annulled': true } },
  4: { text: 'Comisión', classes: { 'bg-comision': true } },
  5: { text: 'Abono a<br>deuda', classes: { 'bg-debt': true } },
  6: { text: 'Adelanto de<br>Comisión', classes: { 'bg-comision': true } },
  7: { text: 'Carga Doble', classes: { 'bg-charge-double': true } },
  8: { text: 'Auspicios', classes: { 'bg-auspicious': true } },
};

export const MOVEMENT_TYPE = [
  { value: '1', label: 'Deposito' },
  { value: '2', label: 'Retiro' },
];

export const MOVEMENT_CLASSES: { [key: number]: string } = {
  1: 'bg-positive',
  2: 'bg-negative',
};

export const MOVEMENT_ICON_CLASSES: { [key: number]: string } = {
  1: 'fas fa-credit-card',
  2: 'fas fa-money-bill',
};
